"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/step-permission.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fstep-permission.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepPermissionToJSON = exports.stepPermissionFromJSON = exports.StepPermission = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
/**
 * Step permission. A StepUserGroup may be assigned multiple permissions and a
 * permission may be shared with multiple groups.
 */
var StepPermission;
(function (StepPermission) {
    StepPermission["INVALID_STEP_PERMISSION"] = "INVALID_STEP_PERMISSION";
    /**
     * LEDGER_READ - List arbitrary transactions, payments, get balance.
     */
    StepPermission["LEDGER_READ"] = "LEDGER_READ";
    /**
     * LEDGER_WRITE - Append transactions, record settlement, reconciliation, tag transactions.
     */
    StepPermission["LEDGER_WRITE"] = "LEDGER_WRITE";
    /**
     * USER_IMPERSONATE - Can impersonate another user.
     */
    StepPermission["USER_IMPERSONATE"] = "USER_IMPERSONATE";
    /**
     * USER_MANAGE_HIGH_PRIVILEGE - View sensitive user data, perform high privilege operations.
     */
    StepPermission["USER_MANAGE_HIGH_PRIVILEGE"] = "USER_MANAGE_HIGH_PRIVILEGE";
    /**
     * NOTES_MANAGE - Read and write internal notes associated with arbitrary entities.
     */
    StepPermission["NOTES_MANAGE"] = "NOTES_MANAGE";
    /**
     * MERCHANTS_MANAGE - Read and update merchant details, user reported locations.
     */
    StepPermission["MERCHANTS_MANAGE"] = "MERCHANTS_MANAGE";
    /**
     * AUDIT_LOGS_READ - View audit logs.
     */
    StepPermission["AUDIT_LOGS_READ"] = "AUDIT_LOGS_READ";
    /**
     * ADMIN_BATCH_READ - View admin batches.
     */
    StepPermission["ADMIN_BATCH_READ"] = "ADMIN_BATCH_READ";
    /**
     * ADMIN_BATCH_WRITE - Write admin batches.
     */
    StepPermission["ADMIN_BATCH_WRITE"] = "ADMIN_BATCH_WRITE";
    /**
     * LEDGER_TAG - Tag transactions
     */
    StepPermission["LEDGER_TAG"] = "LEDGER_TAG";
    /**
     * ENG_ADMIN - Perform eng administrative actions.
     */
    StepPermission["ENG_ADMIN"] = "ENG_ADMIN";
    /**
     * ADMIN_QUEUE_READ - Read access for Admin Queue.
     */
    StepPermission["ADMIN_QUEUE_READ"] = "ADMIN_QUEUE_READ";
    /**
     * ADMIN_QUEUE_WRITE - Write access for Admin Queue.
     */
    StepPermission["ADMIN_QUEUE_WRITE"] = "ADMIN_QUEUE_WRITE";
    /**
     * BLOBSTORE_READ - Read access for Blobstore.
     */
    StepPermission["BLOBSTORE_READ"] = "BLOBSTORE_READ";
    /**
     * BLOBSTORE_WRITE - Write access for Blobstore.
     */
    StepPermission["BLOBSTORE_WRITE"] = "BLOBSTORE_WRITE";
    /**
     * USER_FEATURE_READ - Read user features.
     */
    StepPermission["USER_FEATURE_READ"] = "USER_FEATURE_READ";
    /**
     * USER_FEATURE_WRITE - Change user features.
     */
    StepPermission["USER_FEATURE_WRITE"] = "USER_FEATURE_WRITE";
    /**
     * AML_ESCALATE - Escalate AML cases.
     */
    StepPermission["AML_ESCALATE"] = "AML_ESCALATE";
    /**
     * PROFILE_READ - Read access for user information.
     */
    StepPermission["PROFILE_READ"] = "PROFILE_READ";
    /**
     * PROFILE_WRITE - Write access for user information.
     */
    StepPermission["PROFILE_WRITE"] = "PROFILE_WRITE";
    /**
     * AUTH_PROFILE_READ - Read access for user authorization.
     */
    StepPermission["AUTH_PROFILE_READ"] = "AUTH_PROFILE_READ";
    /**
     * AUTH_PROFILE_WRITE - Write access for user authorization.
     */
    StepPermission["AUTH_PROFILE_WRITE"] = "AUTH_PROFILE_WRITE";
    /**
     * ACCOUNT_READ - Read access for account information.
     */
    StepPermission["ACCOUNT_READ"] = "ACCOUNT_READ";
    /**
     * ACCOUNT_WRITE - Write access for account information.
     */
    StepPermission["ACCOUNT_WRITE"] = "ACCOUNT_WRITE";
    /**
     * LIMIT_READ - Read access for for limits and overrides.
     */
    StepPermission["LIMIT_READ"] = "LIMIT_READ";
    /**
     * LIMIT_WRITE - Write access for limits and overrides.
     */
    StepPermission["LIMIT_WRITE"] = "LIMIT_WRITE";
    /**
     * QUOTA_READ - Read access for quotas.
     */
    StepPermission["QUOTA_READ"] = "QUOTA_READ";
    /**
     * QUOTA_WRITE - Write access for quotas.
     */
    StepPermission["QUOTA_WRITE"] = "QUOTA_WRITE";
    /**
     * USER_GROUP_READ - Read access for groups a user belong to.
     */
    StepPermission["USER_GROUP_READ"] = "USER_GROUP_READ";
    /**
     * USER_GROUP_WRITE - Write access for groups a user belong to.
     */
    StepPermission["USER_GROUP_WRITE"] = "USER_GROUP_WRITE";
    /**
     * DISPUTE_READ - Read access for disputes.
     */
    StepPermission["DISPUTE_READ"] = "DISPUTE_READ";
    /**
     * DISPUTE_WRITE - Write access for disputes.
     */
    StepPermission["DISPUTE_WRITE"] = "DISPUTE_WRITE";
    /**
     * DOCUMENT_REQUEST_READ - Read access for document requests.
     */
    StepPermission["DOCUMENT_REQUEST_READ"] = "DOCUMENT_REQUEST_READ";
    /**
     * DOCUMENT_REQUEST_WRITE - Write access for document requests.
     */
    StepPermission["DOCUMENT_REQUEST_WRITE"] = "DOCUMENT_REQUEST_WRITE";
    /**
     * IDENTITY_READ - Read access for identity verification.
     */
    StepPermission["IDENTITY_READ"] = "IDENTITY_READ";
    /**
     * IDENTITY_WRITE - Write access for identity verification.
     */
    StepPermission["IDENTITY_WRITE"] = "IDENTITY_WRITE";
    /**
     * TRANSFER_READ - Read access for transfers.
     */
    StepPermission["TRANSFER_READ"] = "TRANSFER_READ";
    /**
     * TRANSFER_WRITE - Write access for transfers.
     */
    StepPermission["TRANSFER_WRITE"] = "TRANSFER_WRITE";
    /**
     * USER_CAMPAIGN_READ - Read access for user campaigns.
     */
    StepPermission["USER_CAMPAIGN_READ"] = "USER_CAMPAIGN_READ";
    /**
     * USER_CAMPAIGN_WRITE - Write access for user campaigns.
     */
    StepPermission["USER_CAMPAIGN_WRITE"] = "USER_CAMPAIGN_WRITE";
    /**
     * USER_REFERRAL_READ - Read access for user referral code operations.
     */
    StepPermission["USER_REFERRAL_READ"] = "USER_REFERRAL_READ";
    /**
     * USER_REFERRAL_WRITE - Write access for user referral code operations.
     */
    StepPermission["USER_REFERRAL_WRITE"] = "USER_REFERRAL_WRITE";
    /**
     * USER_DASHBOARD - Dashboard functionality for managing users
     */
    StepPermission["USER_DASHBOARD"] = "USER_DASHBOARD";
    /**
     * CREDIT_REPORT_READ - Read access for user credit reports.
     */
    StepPermission["CREDIT_REPORT_READ"] = "CREDIT_REPORT_READ";
    /**
     * USER_RISK_READ - Access to user risk related information e.g risk graph.
     */
    StepPermission["USER_RISK_READ"] = "USER_RISK_READ";
    /**
     * CUSTOMER_TRANSFER - Ability to fund/recoup customer accounts, also subject to quotas.
     */
    StepPermission["CUSTOMER_TRANSFER"] = "CUSTOMER_TRANSFER";
    /**
     * ADMIN_BATCH_EXECUTE - Enable/disable an admin batch job.
     *
     * @deprecated
     */
    StepPermission["ADMIN_BATCH_EXECUTE"] = "ADMIN_BATCH_EXECUTE";
    /**
     * CHECK_DEPOSIT_SETTLEMENT_WRITE - Upload check deposit settlement report
     * - deprecated: use SETTLEMENT_WRITE instead
     *
     * @deprecated
     */
    StepPermission["CHECK_DEPOSIT_SETTLEMENT_WRITE"] = "CHECK_DEPOSIT_SETTLEMENT_WRITE";
    /**
     * BLOCKS_MANAGE - Manage user blocks: merchants and foreign transactions.
     */
    StepPermission["BLOCKS_MANAGE"] = "BLOCKS_MANAGE";
    /**
     * STOCKS_TRADE - Create stock orders (buy or sell)
     */
    StepPermission["STOCKS_TRADE"] = "STOCKS_TRADE";
    /**
     * CRYPTO_TRADE - Create crypto trade (buy or sell)
     */
    StepPermission["CRYPTO_TRADE"] = "CRYPTO_TRADE";
    /**
     * AML_CASE_READ - Read access for AML cases
     */
    StepPermission["AML_CASE_READ"] = "AML_CASE_READ";
    /**
     * AML_CASE_WRITE - Write access for AML cases
     */
    StepPermission["AML_CASE_WRITE"] = "AML_CASE_WRITE";
    /**
     * STOCK_INSTRUMENT_READ - Read access for stock instruments and categories.
     */
    StepPermission["STOCK_INSTRUMENT_READ"] = "STOCK_INSTRUMENT_READ";
    /**
     * STOCK_INSTRUMENT_WRITE - Write access for stock instruments and categories.
     */
    StepPermission["STOCK_INSTRUMENT_WRITE"] = "STOCK_INSTRUMENT_WRITE";
    /**
     * CRYPTO_ACCOUNT_READ - Read access for crypto account information.
     */
    StepPermission["CRYPTO_ACCOUNT_READ"] = "CRYPTO_ACCOUNT_READ";
    /**
     * CRYPTO_ACCOUNT_WRITE - Write access for crypto account information.
     */
    StepPermission["CRYPTO_ACCOUNT_WRITE"] = "CRYPTO_ACCOUNT_WRITE";
    /**
     * SSN_LAST_4_READ - Read a users last 4 of SSN
     */
    StepPermission["SSN_LAST_4_READ"] = "SSN_LAST_4_READ";
    /**
     * CHECK_DEPOSIT_ACCOUNT_WRITE - Write access for check deposit (allow to issue return)
     */
    StepPermission["CHECK_DEPOSIT_ACCOUNT_WRITE"] = "CHECK_DEPOSIT_ACCOUNT_WRITE";
    /**
     * FTP_READ - Read access for FTP files & directories.
     */
    StepPermission["FTP_READ"] = "FTP_READ";
    /**
     * DISPUTE_WRITE_HIGH_PRIVILEGE - Disable of issuing dispute provisional credit
     */
    StepPermission["DISPUTE_WRITE_HIGH_PRIVILEGE"] = "DISPUTE_WRITE_HIGH_PRIVILEGE";
    /**
     * DISPUTE_CREATE - Create access for disputes, NOT write.
     */
    StepPermission["DISPUTE_CREATE"] = "DISPUTE_CREATE";
    /**
     * USER_LENDING_WRITE - Write access for user lending.
     */
    StepPermission["USER_LENDING_WRITE"] = "USER_LENDING_WRITE";
    /**
     * SETTLEMENT_WRITE - Write settlement related information.
     */
    StepPermission["SETTLEMENT_WRITE"] = "SETTLEMENT_WRITE";
    /**
     * AUTHORIZATION_BLOCK_READ - Read access for authorization blocks.
     */
    StepPermission["AUTHORIZATION_BLOCK_READ"] = "AUTHORIZATION_BLOCK_READ";
    /**
     * AUTHORIZATION_BLOCK_WRITE - Write access for authorization blocks.
     */
    StepPermission["AUTHORIZATION_BLOCK_WRITE"] = "AUTHORIZATION_BLOCK_WRITE";
    /**
     * USER_UNDERWRITING_WRITE - Write access for eligibility information editing.
     */
    StepPermission["USER_UNDERWRITING_WRITE"] = "USER_UNDERWRITING_WRITE";
    /**
     * FEATURE_ROLLOUT_WRITE - Update feature rollouts
     */
    StepPermission["FEATURE_ROLLOUT_WRITE"] = "FEATURE_ROLLOUT_WRITE";
    /**
     * ADMIN_LLM_CHAT - Use LLM admin service chat interface.
     */
    StepPermission["ADMIN_LLM_CHAT"] = "ADMIN_LLM_CHAT";
    /**
     * STOCK_ASSET_TRANSFER_WRITE - Write access for stock asset transfers.
     */
    StepPermission["STOCK_ASSET_TRANSFER_WRITE"] = "STOCK_ASSET_TRANSFER_WRITE";
    /**
     * ADMIN_BATCH_WRITE_QUERY - Update the query parrt of an admin batch job.
     */
    StepPermission["ADMIN_BATCH_WRITE_QUERY"] = "ADMIN_BATCH_WRITE_QUERY";
    StepPermission["UNRECOGNIZED"] = "UNRECOGNIZED";
})(StepPermission || (exports.StepPermission = StepPermission = {}));
function stepPermissionFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STEP_PERMISSION':
            return StepPermission.INVALID_STEP_PERMISSION;
        case 2:
        case 'LEDGER_READ':
            return StepPermission.LEDGER_READ;
        case 3:
        case 'LEDGER_WRITE':
            return StepPermission.LEDGER_WRITE;
        case 4:
        case 'USER_IMPERSONATE':
            return StepPermission.USER_IMPERSONATE;
        case 8:
        case 'USER_MANAGE_HIGH_PRIVILEGE':
            return StepPermission.USER_MANAGE_HIGH_PRIVILEGE;
        case 6:
        case 'NOTES_MANAGE':
            return StepPermission.NOTES_MANAGE;
        case 7:
        case 'MERCHANTS_MANAGE':
            return StepPermission.MERCHANTS_MANAGE;
        case 9:
        case 'AUDIT_LOGS_READ':
            return StepPermission.AUDIT_LOGS_READ;
        case 10:
        case 'ADMIN_BATCH_READ':
            return StepPermission.ADMIN_BATCH_READ;
        case 11:
        case 'ADMIN_BATCH_WRITE':
            return StepPermission.ADMIN_BATCH_WRITE;
        case 12:
        case 'LEDGER_TAG':
            return StepPermission.LEDGER_TAG;
        case 13:
        case 'ENG_ADMIN':
            return StepPermission.ENG_ADMIN;
        case 14:
        case 'ADMIN_QUEUE_READ':
            return StepPermission.ADMIN_QUEUE_READ;
        case 15:
        case 'ADMIN_QUEUE_WRITE':
            return StepPermission.ADMIN_QUEUE_WRITE;
        case 16:
        case 'BLOBSTORE_READ':
            return StepPermission.BLOBSTORE_READ;
        case 17:
        case 'BLOBSTORE_WRITE':
            return StepPermission.BLOBSTORE_WRITE;
        case 18:
        case 'USER_FEATURE_READ':
            return StepPermission.USER_FEATURE_READ;
        case 19:
        case 'USER_FEATURE_WRITE':
            return StepPermission.USER_FEATURE_WRITE;
        case 20:
        case 'AML_ESCALATE':
            return StepPermission.AML_ESCALATE;
        case 21:
        case 'PROFILE_READ':
            return StepPermission.PROFILE_READ;
        case 22:
        case 'PROFILE_WRITE':
            return StepPermission.PROFILE_WRITE;
        case 23:
        case 'AUTH_PROFILE_READ':
            return StepPermission.AUTH_PROFILE_READ;
        case 24:
        case 'AUTH_PROFILE_WRITE':
            return StepPermission.AUTH_PROFILE_WRITE;
        case 25:
        case 'ACCOUNT_READ':
            return StepPermission.ACCOUNT_READ;
        case 26:
        case 'ACCOUNT_WRITE':
            return StepPermission.ACCOUNT_WRITE;
        case 27:
        case 'LIMIT_READ':
            return StepPermission.LIMIT_READ;
        case 28:
        case 'LIMIT_WRITE':
            return StepPermission.LIMIT_WRITE;
        case 29:
        case 'QUOTA_READ':
            return StepPermission.QUOTA_READ;
        case 30:
        case 'QUOTA_WRITE':
            return StepPermission.QUOTA_WRITE;
        case 31:
        case 'USER_GROUP_READ':
            return StepPermission.USER_GROUP_READ;
        case 32:
        case 'USER_GROUP_WRITE':
            return StepPermission.USER_GROUP_WRITE;
        case 33:
        case 'DISPUTE_READ':
            return StepPermission.DISPUTE_READ;
        case 34:
        case 'DISPUTE_WRITE':
            return StepPermission.DISPUTE_WRITE;
        case 35:
        case 'DOCUMENT_REQUEST_READ':
            return StepPermission.DOCUMENT_REQUEST_READ;
        case 36:
        case 'DOCUMENT_REQUEST_WRITE':
            return StepPermission.DOCUMENT_REQUEST_WRITE;
        case 37:
        case 'IDENTITY_READ':
            return StepPermission.IDENTITY_READ;
        case 38:
        case 'IDENTITY_WRITE':
            return StepPermission.IDENTITY_WRITE;
        case 39:
        case 'TRANSFER_READ':
            return StepPermission.TRANSFER_READ;
        case 40:
        case 'TRANSFER_WRITE':
            return StepPermission.TRANSFER_WRITE;
        case 41:
        case 'USER_CAMPAIGN_READ':
            return StepPermission.USER_CAMPAIGN_READ;
        case 42:
        case 'USER_CAMPAIGN_WRITE':
            return StepPermission.USER_CAMPAIGN_WRITE;
        case 43:
        case 'USER_REFERRAL_READ':
            return StepPermission.USER_REFERRAL_READ;
        case 44:
        case 'USER_REFERRAL_WRITE':
            return StepPermission.USER_REFERRAL_WRITE;
        case 45:
        case 'USER_DASHBOARD':
            return StepPermission.USER_DASHBOARD;
        case 46:
        case 'CREDIT_REPORT_READ':
            return StepPermission.CREDIT_REPORT_READ;
        case 47:
        case 'USER_RISK_READ':
            return StepPermission.USER_RISK_READ;
        case 48:
        case 'CUSTOMER_TRANSFER':
            return StepPermission.CUSTOMER_TRANSFER;
        case 49:
        case 'ADMIN_BATCH_EXECUTE':
            return StepPermission.ADMIN_BATCH_EXECUTE;
        case 50:
        case 'CHECK_DEPOSIT_SETTLEMENT_WRITE':
            return StepPermission.CHECK_DEPOSIT_SETTLEMENT_WRITE;
        case 51:
        case 'BLOCKS_MANAGE':
            return StepPermission.BLOCKS_MANAGE;
        case 52:
        case 'STOCKS_TRADE':
            return StepPermission.STOCKS_TRADE;
        case 53:
        case 'CRYPTO_TRADE':
            return StepPermission.CRYPTO_TRADE;
        case 54:
        case 'AML_CASE_READ':
            return StepPermission.AML_CASE_READ;
        case 55:
        case 'AML_CASE_WRITE':
            return StepPermission.AML_CASE_WRITE;
        case 56:
        case 'STOCK_INSTRUMENT_READ':
            return StepPermission.STOCK_INSTRUMENT_READ;
        case 57:
        case 'STOCK_INSTRUMENT_WRITE':
            return StepPermission.STOCK_INSTRUMENT_WRITE;
        case 58:
        case 'CRYPTO_ACCOUNT_READ':
            return StepPermission.CRYPTO_ACCOUNT_READ;
        case 59:
        case 'CRYPTO_ACCOUNT_WRITE':
            return StepPermission.CRYPTO_ACCOUNT_WRITE;
        case 60:
        case 'SSN_LAST_4_READ':
            return StepPermission.SSN_LAST_4_READ;
        case 61:
        case 'CHECK_DEPOSIT_ACCOUNT_WRITE':
            return StepPermission.CHECK_DEPOSIT_ACCOUNT_WRITE;
        case 62:
        case 'FTP_READ':
            return StepPermission.FTP_READ;
        case 63:
        case 'DISPUTE_WRITE_HIGH_PRIVILEGE':
            return StepPermission.DISPUTE_WRITE_HIGH_PRIVILEGE;
        case 64:
        case 'DISPUTE_CREATE':
            return StepPermission.DISPUTE_CREATE;
        case 65:
        case 'USER_LENDING_WRITE':
            return StepPermission.USER_LENDING_WRITE;
        case 66:
        case 'SETTLEMENT_WRITE':
            return StepPermission.SETTLEMENT_WRITE;
        case 67:
        case 'AUTHORIZATION_BLOCK_READ':
            return StepPermission.AUTHORIZATION_BLOCK_READ;
        case 68:
        case 'AUTHORIZATION_BLOCK_WRITE':
            return StepPermission.AUTHORIZATION_BLOCK_WRITE;
        case 69:
        case 'USER_UNDERWRITING_WRITE':
            return StepPermission.USER_UNDERWRITING_WRITE;
        case 70:
        case 'FEATURE_ROLLOUT_WRITE':
            return StepPermission.FEATURE_ROLLOUT_WRITE;
        case 71:
        case 'ADMIN_LLM_CHAT':
            return StepPermission.ADMIN_LLM_CHAT;
        case 72:
        case 'STOCK_ASSET_TRANSFER_WRITE':
            return StepPermission.STOCK_ASSET_TRANSFER_WRITE;
        case 73:
        case 'ADMIN_BATCH_WRITE_QUERY':
            return StepPermission.ADMIN_BATCH_WRITE_QUERY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return StepPermission.UNRECOGNIZED;
    }
}
exports.stepPermissionFromJSON = stepPermissionFromJSON;
function stepPermissionToJSON(object) {
    switch (object) {
        case StepPermission.INVALID_STEP_PERMISSION:
            return 'INVALID_STEP_PERMISSION';
        case StepPermission.LEDGER_READ:
            return 'LEDGER_READ';
        case StepPermission.LEDGER_WRITE:
            return 'LEDGER_WRITE';
        case StepPermission.USER_IMPERSONATE:
            return 'USER_IMPERSONATE';
        case StepPermission.USER_MANAGE_HIGH_PRIVILEGE:
            return 'USER_MANAGE_HIGH_PRIVILEGE';
        case StepPermission.NOTES_MANAGE:
            return 'NOTES_MANAGE';
        case StepPermission.MERCHANTS_MANAGE:
            return 'MERCHANTS_MANAGE';
        case StepPermission.AUDIT_LOGS_READ:
            return 'AUDIT_LOGS_READ';
        case StepPermission.ADMIN_BATCH_READ:
            return 'ADMIN_BATCH_READ';
        case StepPermission.ADMIN_BATCH_WRITE:
            return 'ADMIN_BATCH_WRITE';
        case StepPermission.LEDGER_TAG:
            return 'LEDGER_TAG';
        case StepPermission.ENG_ADMIN:
            return 'ENG_ADMIN';
        case StepPermission.ADMIN_QUEUE_READ:
            return 'ADMIN_QUEUE_READ';
        case StepPermission.ADMIN_QUEUE_WRITE:
            return 'ADMIN_QUEUE_WRITE';
        case StepPermission.BLOBSTORE_READ:
            return 'BLOBSTORE_READ';
        case StepPermission.BLOBSTORE_WRITE:
            return 'BLOBSTORE_WRITE';
        case StepPermission.USER_FEATURE_READ:
            return 'USER_FEATURE_READ';
        case StepPermission.USER_FEATURE_WRITE:
            return 'USER_FEATURE_WRITE';
        case StepPermission.AML_ESCALATE:
            return 'AML_ESCALATE';
        case StepPermission.PROFILE_READ:
            return 'PROFILE_READ';
        case StepPermission.PROFILE_WRITE:
            return 'PROFILE_WRITE';
        case StepPermission.AUTH_PROFILE_READ:
            return 'AUTH_PROFILE_READ';
        case StepPermission.AUTH_PROFILE_WRITE:
            return 'AUTH_PROFILE_WRITE';
        case StepPermission.ACCOUNT_READ:
            return 'ACCOUNT_READ';
        case StepPermission.ACCOUNT_WRITE:
            return 'ACCOUNT_WRITE';
        case StepPermission.LIMIT_READ:
            return 'LIMIT_READ';
        case StepPermission.LIMIT_WRITE:
            return 'LIMIT_WRITE';
        case StepPermission.QUOTA_READ:
            return 'QUOTA_READ';
        case StepPermission.QUOTA_WRITE:
            return 'QUOTA_WRITE';
        case StepPermission.USER_GROUP_READ:
            return 'USER_GROUP_READ';
        case StepPermission.USER_GROUP_WRITE:
            return 'USER_GROUP_WRITE';
        case StepPermission.DISPUTE_READ:
            return 'DISPUTE_READ';
        case StepPermission.DISPUTE_WRITE:
            return 'DISPUTE_WRITE';
        case StepPermission.DOCUMENT_REQUEST_READ:
            return 'DOCUMENT_REQUEST_READ';
        case StepPermission.DOCUMENT_REQUEST_WRITE:
            return 'DOCUMENT_REQUEST_WRITE';
        case StepPermission.IDENTITY_READ:
            return 'IDENTITY_READ';
        case StepPermission.IDENTITY_WRITE:
            return 'IDENTITY_WRITE';
        case StepPermission.TRANSFER_READ:
            return 'TRANSFER_READ';
        case StepPermission.TRANSFER_WRITE:
            return 'TRANSFER_WRITE';
        case StepPermission.USER_CAMPAIGN_READ:
            return 'USER_CAMPAIGN_READ';
        case StepPermission.USER_CAMPAIGN_WRITE:
            return 'USER_CAMPAIGN_WRITE';
        case StepPermission.USER_REFERRAL_READ:
            return 'USER_REFERRAL_READ';
        case StepPermission.USER_REFERRAL_WRITE:
            return 'USER_REFERRAL_WRITE';
        case StepPermission.USER_DASHBOARD:
            return 'USER_DASHBOARD';
        case StepPermission.CREDIT_REPORT_READ:
            return 'CREDIT_REPORT_READ';
        case StepPermission.USER_RISK_READ:
            return 'USER_RISK_READ';
        case StepPermission.CUSTOMER_TRANSFER:
            return 'CUSTOMER_TRANSFER';
        case StepPermission.ADMIN_BATCH_EXECUTE:
            return 'ADMIN_BATCH_EXECUTE';
        case StepPermission.CHECK_DEPOSIT_SETTLEMENT_WRITE:
            return 'CHECK_DEPOSIT_SETTLEMENT_WRITE';
        case StepPermission.BLOCKS_MANAGE:
            return 'BLOCKS_MANAGE';
        case StepPermission.STOCKS_TRADE:
            return 'STOCKS_TRADE';
        case StepPermission.CRYPTO_TRADE:
            return 'CRYPTO_TRADE';
        case StepPermission.AML_CASE_READ:
            return 'AML_CASE_READ';
        case StepPermission.AML_CASE_WRITE:
            return 'AML_CASE_WRITE';
        case StepPermission.STOCK_INSTRUMENT_READ:
            return 'STOCK_INSTRUMENT_READ';
        case StepPermission.STOCK_INSTRUMENT_WRITE:
            return 'STOCK_INSTRUMENT_WRITE';
        case StepPermission.CRYPTO_ACCOUNT_READ:
            return 'CRYPTO_ACCOUNT_READ';
        case StepPermission.CRYPTO_ACCOUNT_WRITE:
            return 'CRYPTO_ACCOUNT_WRITE';
        case StepPermission.SSN_LAST_4_READ:
            return 'SSN_LAST_4_READ';
        case StepPermission.CHECK_DEPOSIT_ACCOUNT_WRITE:
            return 'CHECK_DEPOSIT_ACCOUNT_WRITE';
        case StepPermission.FTP_READ:
            return 'FTP_READ';
        case StepPermission.DISPUTE_WRITE_HIGH_PRIVILEGE:
            return 'DISPUTE_WRITE_HIGH_PRIVILEGE';
        case StepPermission.DISPUTE_CREATE:
            return 'DISPUTE_CREATE';
        case StepPermission.USER_LENDING_WRITE:
            return 'USER_LENDING_WRITE';
        case StepPermission.SETTLEMENT_WRITE:
            return 'SETTLEMENT_WRITE';
        case StepPermission.AUTHORIZATION_BLOCK_READ:
            return 'AUTHORIZATION_BLOCK_READ';
        case StepPermission.AUTHORIZATION_BLOCK_WRITE:
            return 'AUTHORIZATION_BLOCK_WRITE';
        case StepPermission.USER_UNDERWRITING_WRITE:
            return 'USER_UNDERWRITING_WRITE';
        case StepPermission.FEATURE_ROLLOUT_WRITE:
            return 'FEATURE_ROLLOUT_WRITE';
        case StepPermission.ADMIN_LLM_CHAT:
            return 'ADMIN_LLM_CHAT';
        case StepPermission.STOCK_ASSET_TRANSFER_WRITE:
            return 'STOCK_ASSET_TRANSFER_WRITE';
        case StepPermission.ADMIN_BATCH_WRITE_QUERY:
            return 'ADMIN_BATCH_WRITE_QUERY';
        case StepPermission.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.stepPermissionToJSON = stepPermissionToJSON;
//# sourceMappingURL=step-permission.js.map